import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider } from "../../../divider/src";
import { OrderSummaryEmpty } from './OrderSummaryEmpty';
import { OrderSummaryItems } from './OrderSummaryItems';
import { useOrganizedCartItems } from '../hooks/useOrganizedCartItems';
const renderPromoCodes = ({ locale, promoCodes, }) => {
    if (promoCodes.length === 0) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(OrderSummaryItems, { items: promoCodes, locale: locale }), _jsx(Divider, { borderBottomColor: "horizon", mb: 4, mt: 0, width: "100%" })] }));
};
export const OrderSummaryBody = ({ items = [], locale, }) => {
    const { orderedItems, promoCodeItems } = useOrganizedCartItems({ items });
    if (items.length === 0) {
        return _jsx(OrderSummaryEmpty, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(OrderSummaryItems, { items: orderedItems, locale: locale }), _jsx(Divider, { borderBottomColor: "horizon", mb: 4, mt: 0, width: "100%" }), renderPromoCodes({ locale, promoCodes: promoCodeItems })] }));
};
//# sourceMappingURL=OrderSummaryBody.js.map